import { InitiativesEffects } from './initiatives.effect';
import { MyInitiativesEffects } from './my-initiatives.effect';
export * from './initiatives.effect';
export * from './my-initiatives.effect';
export const effects = [InitiativesEffects, MyInitiativesEffects];
